import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@shared/api';
import { channelQueryKeys } from './queries';

/** V2-4 этап 5: карточка канала для экранов 6 и 6б (бэкенд `cabinet_channels.py`). */
export interface ChannelCard {
  id: string;
  platform: 'telegram' | 'max' | 'widget';
  status: 'active' | 'paused' | 'disabled';
  /** Окно чата — имя ассистента в шапке окна; бот — @адрес. */
  title: string;
  bot_username: string | null;
  bot_display_name: string | null;
  /** Окно чата: сайты без https:// и www. */
  sites: string[];
  created_at: string;
  last_error: string | null;
  messages_7d: number;
  messages_24h: number;
  messages_total: number;
  dialogs: number;
  subscribers: number;
}

export const channelCardsKey = (aid: string) => [...channelQueryKeys.all, 'cards', aid] as const;

export function useChannelCards(aid: string | undefined) {
  return useQuery<ChannelCard[], Error>({
    queryKey: channelCardsKey(aid ?? ''),
    queryFn: async () =>
      (await httpClient.get<ChannelCard[]>(`/assistants/${aid}/channels-overview`)).data,
    enabled: !!aid,
  });
}

/** Ссылка «Открыть бота». */
export function botLink(c: Pick<ChannelCard, 'platform' | 'bot_username'>) {
  // У MAX-бота без @username мы храним служебное «max_bot_<id>» — ссылки на него нет.
  if (!c.bot_username || c.bot_username.startsWith('max_bot_') || c.bot_username === 'tg_bot')
    return null;
  return c.platform === 'telegram'
    ? `https://t.me/${c.bot_username}`
    : `https://max.ru/${c.bot_username}`; // без @: сверено на живом боте 29.10.2026
}
